import Discover from "../../../front-pages/discover/_components/Discover";
import { MotionModal, ModalCloseButton } from "../../../../components/motion";

// "Edit booking" popup on the cart page: the booking form inside a large popup.
const NewEditBooking = ({
  useModal = false,
  handleCloseModal,
  typeOfTransfer,
  keyBook,
  bookingFormData,
}) => {
  return (
    <MotionModal
      show={useModal}
      onClose={handleCloseModal}
      maxWidthClassName="tw:sm:max-w-[500px] tw:xl:max-w-[1140px]"
      panelClassName="border-top-gold"
    >
      <div className="tw:relative tw:flex-1 tw:p-4 tw:px-6">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:justify-end">
          <ModalCloseButton isInline onClick={handleCloseModal} />
        </div>
        <Discover
          isEditBooking={true}
          keyBook={keyBook}
        />
      </div>
    </MotionModal>
  );
};
export default NewEditBooking;
